module.exports = __webpack_public_path__ + "img/event-space.d9a5b2b.jpg";